module.exports = __webpack_public_path__ + "static/media/diving_1600.4da3af6c.webp";